//
require('./script/0-1.detect.js');
require('./script/0-2.loader.js');